// extracted by mini-css-extract-plugin
export default {"header":"newExternalAddress_header__59R5m","active":"newExternalAddress_active__qiKaJ","modal":"newExternalAddress_modal__2gccM"};